import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/Navbar.css';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [blogEnabled, setBlogEnabled] = useState(false);

  React.useEffect(() => {
    fetch('/api/home-content')
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setBlogEnabled(data.content?.settings?.blogEnabled || false);
        }
      })
      .catch(err => console.error('Error fetching settings:', err));
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Get the opposite language
  const alternativeLanguage = i18n.language === 'pt' ? 'en' : 'pt';
  const languageLabel = alternativeLanguage.toUpperCase();

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          🔮 Sara M. White
        </Link>

        <button 
          className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <Link to="/" onClick={closeMenu}>
              {t('nav.home')}
            </Link>
          </li>
          <li>
            <Link to="/services" onClick={closeMenu}>
              {t('nav.services')}
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={closeMenu}>
              {t('nav.about')}
            </Link>
          </li>
          {blogEnabled && (
            <li>
              <Link to="/blog" onClick={closeMenu}>
                {t('nav.blog')}
              </Link>
            </li>
          )}
          <li>
            <Link to="/contact" onClick={closeMenu}>
              {t('nav.contact')}
            </Link>
          </li>
          <li>
            <Link to="/booking" className="btn-book" onClick={closeMenu}>
              {t('nav.booking')}
            </Link>
          </li>
          
          <li className="language-switcher">
            <button 
              className="lang-btn"
              onClick={() => changeLanguage(alternativeLanguage)}
              aria-label={`Switch to ${languageLabel}`}
            >
              {languageLabel}
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
